
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import { EnumCompleteType } from '@xt/client/enums/kindred-spirit'
import type { UserInfo } from '@xt/client/entities/user/types'
import EntrySub from './EntrySub/index.vue'
import EntryMain from './EntryMain/index.vue'
import { type UserFieldConfig } from '@xt/client/entities/kindred-spirit/kindred-spirit'

const USER_COMPLETE_CONFIG: Array<
  Omit<UserFieldConfig, 'finished'> & {
    field: keyof UserInfo
  }
> = [
  {
    field: 'phoneNum',
    icon: 'phone',
    key: EnumCompleteType.PhoneNum,
    label: '填写手机号',
    desc: '方便负责人与你联系'
  },
  {
    field: 'wxUsername',
    icon: 'wechat',
    key: EnumCompleteType.WeChat,
    label: '填写微信号',
    desc: '方便负责人邀请你加入群聊'
  },
  {
    field: 'summary',
    icon: 'summary',
    key: EnumCompleteType.Summary,
    label: '填写简介',
    desc: '让桐学快速了解你'
  },
  {
    field: 'specialty',
    icon: 'specialtyv2',
    key: EnumCompleteType.Specialty,
    label: '填写特长',
    desc: '分享你的兴趣与擅长'
  }
]

@Observer
@Component({
  components: {
    EntrySub,
    EntryMain
  }
})
export default class EntryModal extends Vue {
  visible: boolean = false
  needCompleteList: Array<UserFieldConfig> = []

  panelKey: 'main' | 'sub' = 'main'
  subKey: EnumCompleteType = EnumCompleteType.PhoneNum

  get transStyle() {
    return this.panelKey === 'main' ? { transform: 'translateX(0)' } : { transform: 'translateX(-396px)' }
  }

  get UserInfo() {
    return this.$store.$storeUser.UserInfo
  }

  get process() {
    return Math.max(0, Math.min(4, USER_COMPLETE_CONFIG.length - this.needCompleteList.filter(i => !i.finished).length))
  }

  handleFinish(key: EnumCompleteType) {
    const index = this.needCompleteList.findIndex(i => i.key === key)

    if (index === -1) return

    this.needCompleteList[index].finished = true

    this.onBack()
  }

  onBack() {
    this.panelKey = 'main'
  }

  toSub(key: EnumCompleteType) {
    if (this.panelKey === 'sub') return

    this.panelKey = 'sub'

    switch (key) {
      case EnumCompleteType.PhoneNum:
        this.subKey = EnumCompleteType.PhoneNum
        break
      case EnumCompleteType.WeChat:
        this.subKey = EnumCompleteType.WeChat
        break
      case EnumCompleteType.Summary:
        this.subKey = EnumCompleteType.Summary
        break
      case EnumCompleteType.Specialty:
        this.subKey = EnumCompleteType.Specialty
        break
    }
  }

  initNeedCompleteList() {
    const res: Array<UserFieldConfig> = []

    USER_COMPLETE_CONFIG.forEach(config => {
      res.push({
        key: config.key,
        label: config.label,
        desc: config.desc,
        icon: config.icon,
        finished: !!this.UserInfo[config.field]
      })
    })

    this.needCompleteList = res
  }

  show() {
    this.initNeedCompleteList()

    if (this.needCompleteList.filter(i => !i.finished).length === 0) return

    this.visible = true
  }

  hide() {
    this.visible = false
  }

  @Emit('closed')
  onClosed() {}

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
